import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_URLS } from "../../configs/api.urls";
import ImageModal from "./modals/ImageModal";
import { Table } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import { setSelectedMarkSide } from "../../store/actions/inspection.action";
import GenerateInspectionReport from "./GenerateInspectionReport";
import { pdf } from "@react-pdf/renderer";

export const parseSignature = (signature) => {
  if (signature.startsWith("data:image/png;base64,")) {
    return signature;
  } else {
    return "data:image/png;base64," + signature;
  }
};

const InspectionReport = () => {
  const index = useSelector((state) => state.inspectionReducer.recordIndex);
  const activeVehicle = useSelector(
    (state) => state.inspectionReducer.activeVehicle
  );
  const vehicleId = activeVehicle?.inspectionDetails?._id;

  const records = useSelector(
    (state) => state.inspectionReducer.inspectionRecords
  );
  const dispatch = useDispatch();

  const [report, setReport] = useState({});
  const [prevReport, setPrevReport] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [modalDataType, setModalDataType] = useState(null);
  const [modalTitle, setModalTitle] = useState("");

  const toggleImageModal = () => {
    setShowImagesModal((prev) => !prev);
  };

  const imageClicked = (type, index) => {
    setModalDataType(type);
    setModalTitle(`Inspection ${type.charAt(0).toUpperCase() + type.slice(1)}`);
    if (type == "marks") setModalData(report.marks);
    if (type == "photos") setModalData(report.photos);
    setSelectedImageIndex(index);
    toggleImageModal();
  };

  const parsePrevReportField = (fieldType, key) => {
    //TODO change mandatoryFields & optionalFields from array to object
    if (prevReport !== null) {
      for (const field of prevReport[fieldType]) {
        if (field.key === key) {
          return parseFieldValue(field, true);
        }
      }
    }
    return "--";
  };

  const parseFieldValue = (field, isPrev = false) => {
    let value;
    if (field.type === "checkbox") {
      field.data
        ? field.data === "on" || true
          ? (value = (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill={isPrev ? "#3f3f4690" : "#16a34a"}
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                style={{ height: "25px" }}
              >
                <path
                  fillRule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                  clipRule="evenodd"
                />
              </svg>
            ))
          : (value = (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill={isPrev ? "#3f3f4690" : "#b91c1c"}
                style={{ height: "25px" }}
              >
                <path
                  fillRule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                  clipRule="evenodd"
                />
              </svg>
            ))
        : (value = (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill={isPrev ? "#3f3f4690" : "#b91c1c"}
              style={{ height: "25px" }}
            >
              <path
                fillRule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                clipRule="evenodd"
              />
            </svg>
          ));
    } else {
      value = field.data ?? "--";
    }
    return value;
  };

  useEffect(() => {
    if (records[vehicleId] !== undefined) {
      setReport(records[vehicleId][index] ?? {});
      setPrevReport(records[vehicleId][index + 1] ?? null);
    }
  }, [records, activeVehicle, index]);

  const handlePDFDownload = async () => {
    try {
      const blob = await pdf(
        <GenerateInspectionReport report={report} />
      ).toBlob();
      saveAs(blob, `${report?.vehicle?.vehicleName}- Inspection Report.pdf`);
    } catch (error) {
      console.log("Error while Generating PDF", error);
    }
  };

  return (
    <>
      <ImageModal
        photos={modalData}
        type={modalDataType}
        show={showImagesModal}
        toggleModal={toggleImageModal}
        activeIndex={selectedImageIndex}
        title={modalTitle}
      />
      <div className="d-flex w-full">
        {Object.keys(report).length !== 0 && (
          <div className=" px-3 pb-6  w-100">
            <div className="d-flex align-items-center justify-content-between mb-2 mt-4">
              <p className="font-weight-bold mb-0 text-secondary">
                Inspection Report
              </p>
              <i
                className="fa fa-download text-primary pointer"
                aria-hidden="true"
                onClick={() => handlePDFDownload()}
              ></i>
            </div>
            {report?.mandatory.length ? (
              <table className="w-100 table-hover mt-4 overflow-auto">
                <thead>
                  <tr className="w-full">
                    <th scope="col">
                      <p className="mb-0" style={styles.sectionHeading}>
                        Mandatory
                      </p>
                    </th>
                    <th scope="col">
                      <p className="text-secondary mb-0 text-center">Prev</p>
                    </th>
                    <th scope="col">
                      <p className="mb-0 text-center">Current</p>
                    </th>
                  </tr>
                </thead>
                <tbody className="overflow-auto block">
                  {report?.mandatory.map((field, index) => (
                    <tr key={index} scope="row" className="w-100 py-2 ">
                      <td>
                        <p className="mb-0 px-1">{field.key}</p>
                      </td>
                      <td className="mx-auto">
                        {field.type !== "checkbox" ? (
                          <ReactTooltip id={`prev ${field.key}`} />
                        ) : (
                          ""
                        )}
                        <p
                          data-for={`prev ${field.key}`}
                          data-tip={parsePrevReportField(
                            "mandatory",
                            field.key
                          )}
                          className="mb-0 text-center max-width-10 text-secondary mx-auto"
                        >
                          {parsePrevReportField("mandatory", field.key)}
                        </p>
                      </td>
                      <td>
                        {field.type !== "checkbox" && field.data ? (
                          <ReactTooltip id={`current ${field.key}`} />
                        ) : (
                          ""
                        )}
                        <p
                          data-for={`current ${field.key}`}
                          data-tip={field.data}
                          className="mb-0 max-width-10 mx-auto text-center"
                        >
                          {parseFieldValue(field)}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              ""
            )}
            {report?.optional.length ? (
              <table className="w-100 table-hover mt-4 overflow-auto">
                <thead>
                  <tr className="w-full">
                    <th scope="col">
                      <p className="mb-0" style={styles.sectionHeading}>
                        Optional
                      </p>
                    </th>
                    <th scope="col">
                      <p className="text-secondary mb-0 text-center">Prev</p>
                    </th>
                    <th scope="col">
                      <p className="mb-0 text-center">Current</p>
                    </th>
                  </tr>
                </thead>
                <tbody className="overflow-auto block">
                  {report?.optional.map((field, index) => (
                    <tr key={index} scope="row" className="w-100 py-2 ">
                      <td>
                        <p className="mb-0 px-1">{field.key}</p>
                      </td>
                      <td>
                        {field.type !== "checkbox" ? (
                          <ReactTooltip id={`prev ${field.key}`} />
                        ) : (
                          ""
                        )}
                        <p
                          data-for={`prev ${field.key}`}
                          data-tip={parsePrevReportField("optional", field.key)}
                          className="mb-0 text-center max-width-10 text-secondary mx-auto"
                        >
                          {parsePrevReportField("optional", field.key)}
                        </p>
                      </td>
                      <td>
                        {field.type !== "checkbox" && field.data ? (
                          <ReactTooltip id={`current ${field.key}`} />
                        ) : (
                          ""
                        )}
                        <p
                          data-for={`current ${field.key}`}
                          data-tip={field.data}
                          className="mb-0 max-width-10 mx-auto text-center"
                        >
                          {parseFieldValue(field)}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              ""
            )}
            {report?.marks.length ? (
              <>
                <p style={styles.sectionHeading} className="mt-4">
                  Scratches/Dents
                </p>
                {report?.marks.map((mark, index) => (
                  <div
                    onClick={() => dispatch(setSelectedMarkSide(mark?.side))}
                    key={index}
                    style={{ gap: "10px", cursor: "pointer" }}
                    className="tile d-flex align-items-start rounded mb-1 p-2 justify-content-start "
                  >
                    <img
                      onClick={() => imageClicked("marks", index)}
                      src={API_URLS.ASSETS_BACKEND_URL + "/" + mark.imagePath}
                      className="my-auto"
                      style={{
                        objectFit: "cover",
                        height: "50px",
                        width: "50px",
                      }}
                      alt={mark?.markType}
                      onError={(event) => {
                        event.target.src =
                          "https://img.icons8.com/parakeet-line/48/remove-image.png";
                        event.onerror = null;
                      }}
                    />
                    <div className="w-100">
                      <div className="w-100 mb-1 d-flex align-items-center justify-content-between">
                        <p className="text-capitalize mb-0 heading-small">
                          {mark?.markType}
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            letterSpacing: "0.25px",
                          }}
                          className="text-capitalize mb-0 bg-primary text-white px-1 rounded"
                        >
                          {mark?.side}
                        </p>
                      </div>
                      {!mark.description ? (
                        <p className="text-secondary font-italic">
                          No Description
                        </p>
                      ) : (
                        <p className="mb-0">{mark.description}</p>
                      )}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              ""
            )}
            {report?.photos.length ? (
              <>
                <p style={styles.sectionHeading} className="mt-4">
                  Photos
                </p>
                <div className="photos-grid">
                  {report?.photos.map((photo, index) => (
                    <img
                      key={index}
                      onClick={() => imageClicked("photos", index)}
                      className="col w-100"
                      style={{ cursor: "pointer" }}
                      src={API_URLS.ASSETS_BACKEND_URL + "/" + photo}
                      // width={100}
                      onError={(event) => {
                        event.target.src =
                          "https://img.icons8.com/parakeet-line/48/remove-image.png";
                        event.onerror = null;
                      }}
                      alt="photo of vehicle"
                    />
                  ))}
                </div>
              </>
            ) : (
              ""
            )}
            {report?.remarks?.length ? (
              <>
                <p style={styles.sectionHeading} className="mt-4">
                  Remarks
                </p>
                <p>{report?.remarks}</p>
              </>
            ) : (
              ""
            )}
            {report?.driverSignature?.signature.length ? (
              <>
                <p style={styles.sectionHeading} className="mt-4">
                  Driver Details
                </p>
                <img
                  src={parseSignature(report?.driverSignature?.signature)}
                  height={100}
                  alt="photo of signature"
                />
                <p>{report?.driverSignature?.name}</p>
              </>
            ) : (
              ""
            )}
            {report?.inspectorSignature?.signature.length ? (
              <>
                <p style={styles.sectionHeading} className="mt-4">
                  Inspector Details
                </p>
                <img
                  src={parseSignature(report?.inspectorSignature?.signature)}
                  height={100}
                  alt="photo of signature"
                />
                <p className="text-capitalize">
                  Inspected by: {report?.inspectorSignature?.name}
                </p>
              </>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    </>
  );
};

const styles = {
  sectionHeading: {
    fontWeight: "bold",
    fontSize: "14px",
  },
};

export default InspectionReport;
